import React from 'react';

// Trooper の正式ロゴ（ワードマーク。2026-09 確定版 trooper-logo-final）。
// 色は currentColor で受けるので、text-ink / text-paper などで塗り分ける。
// 画像として使う場合は public/img/trooper/wordmark-*.svg を参照する。
// 「T」と「p」を組み合わせた丸いシンボルは非公式（2026-10-17 代表指示）なので、サイトでは使わない。

const WORDMARK_PATHS = [
  { d: 'M 120 100 H 660 L 540 220 H 390 V 750 H 270 V 220 H 0 Z' },
  { d: 'M 550 750 V 400 L 650 300 H 850 L 730 420 H 710 Q 670 420 670 460 V 750 Z' },
  {
    d: 'M 805 525 a 225 225 0 1 0 450 0 a 225 225 0 1 0 -450 0 Z M 925 525 a 105 105 0 1 0 210 0 a 105 105 0 1 0 -210 0 Z',
    evenodd: true,
  },
  {
    d: 'M 1295 525 a 225 225 0 1 0 450 0 a 225 225 0 1 0 -450 0 Z M 1415 525 a 105 105 0 1 0 210 0 a 105 105 0 1 0 -210 0 Z',
    evenodd: true,
  },
  {
    d: 'M1785 400 L1885 300 H2010 A225 225 0 1 1 1905 723.997487 V920 H1785 Z M1905 525 A105 105 0 1 0 2115 525 A105 105 0 1 0 1905 525 Z',
    evenodd: true,
  },
  {
    d: 'M2716.852484 585 H2413.83156 A105 105 0 0 0 2574.246212 599.246212 L2659.099026 684.099026 A225 225 0 1 1 2716.852484 585 Z M2413.83156 465 H2586.16844 A105 105 0 0 0 2413.83156 465 Z',
    evenodd: true,
  },
  { d: 'M 2770 750 V 400 L 2870 300 H 3070 L 2950 420 H 2930 Q 2890 420 2890 460 V 750 Z' },
];


/** ワードマーク「Trooper」。高さで大きさを決める（例: className="h-8 w-auto"）。 */
export function TrooperWordmark({ className = 'h-8 w-auto', title = 'Trooper' }) {
  return (
    <svg
      viewBox="-10 90 3100 840"
      fill="currentColor"
      role="img"
      aria-label={title}
      className={className}
    >
      {WORDMARK_PATHS.map((p) => (
        <path key={p.d} d={p.d} fillRule={p.evenodd ? 'evenodd' : undefined} />
      ))}
    </svg>
  );
}

